import React, { useState } from 'react';
import { Megaphone, Pause, Play } from 'lucide-react';

export default function MarqueeTicker({ announcements = [] }) {
  const [isPaused, setIsPaused] = useState(false);

  if (!announcements || announcements.length === 0) return null;

  return (
    <section
      className="bg-[#FBFAF0] border-y border-[#E6E6E6]"
      data-testid="marquee-ticker"
    >
      <div className="container-cish">
        <div className="flex items-center gap-2 md:gap-4 py-2 md:py-3">
          {/* Label - Mobile optimized */}
          <div className="flex items-center gap-1.5 md:gap-2 shrink-0 pr-2 md:pr-4 border-r border-[#E6E6E6] self-center">
            <Megaphone className="w-4 h-4 md:w-5 md:h-5 text-[#0E6D2B]" />
            <span className="text-xs md:text-sm font-semibold text-[#0E6D2B] uppercase tracking-wide hidden sm:inline leading-none">
              Announcements
            </span>
          </div>

          {/* Marquee container */}
          <div
            className="flex-1 overflow-hidden flex items-center"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            <div
              className={`flex gap-12 whitespace-nowrap items-center ${isPaused ? '' : 'animate-marquee'}`}
              style={{ animationPlayState: isPaused ? 'paused' : 'running' }}
            >
              {announcements.map((item, index) => (
                <a
                  key={item.id || index}
                  href={item.link_url || '#'}
                  target={item.link_url?.startsWith('http') ? '_blank' : '_self'}
                  rel="noopener noreferrer"
                  className="text-xs md:text-sm text-[#4A4A4A] hover:text-[#0E6D2B] hover:underline leading-none"
                  data-testid={`announcement-${index}`}
                >
                  {item.title}
                </a>
              ))}
              {/* Duplicate for seamless loop */}
              {announcements.map((item, index) => (
                <a
                  key={`dup-${item.id || index}`}
                  href={item.link_url || '#'}
                  target={item.link_url?.startsWith('http') ? '_blank' : '_self'}
                  rel="noopener noreferrer"
                  className="text-xs md:text-sm text-[#4A4A4A] hover:text-[#0E6D2B] hover:underline leading-none"
                  aria-hidden="true"
                >
                  {item.title}
                </a>
              ))}
            </div>
          </div>

          {/* Play/Pause button */}
          <button
            onClick={() => setIsPaused(!isPaused)}
            className="shrink-0 w-8 h-8 flex items-center justify-center text-[#6B6B6B] hover:text-[#0E6D2B] transition-colors self-center"
            aria-label={isPaused ? 'Play' : 'Pause'}
            data-testid="marquee-toggle"
          >
            {isPaused ? <Play className="w-4 h-4" /> : <Pause className="w-4 h-4" />}
          </button>
        </div>
      </div>
    </section>
  );
}
